module.exports = __webpack_public_path__ + "img/big_data.71426807.png";